var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09961 20.4C4.09961 19.7373 4.63687 19.2 5.29961 19.2H19.6996C20.3624 19.2 20.8996 19.7373 20.8996 20.4C20.8996 21.0627 20.3624 21.6 19.6996 21.6H5.29961C4.63687 21.6 4.09961 21.0627 4.09961 20.4ZM8.05108 8.04853C7.58245 7.5799 7.58245 6.8201 8.05108 6.35147L11.6511 2.75147C11.8761 2.52643 12.1813 2.4 12.4996 2.4C12.8179 2.4 13.1231 2.52643 13.3481 2.75147L16.9481 6.35147C17.4168 6.8201 17.4168 7.5799 16.9481 8.04853C16.4795 8.51716 15.7197 8.51716 15.2511 8.04853L13.6996 6.49706L13.6996 15.6C13.6996 16.2627 13.1623 16.8 12.4996 16.8C11.8369 16.8 11.2996 16.2627 11.2996 15.6L11.2996 6.49706L9.74814 8.04853C9.27951 8.51716 8.51971 8.51716 8.05108 8.04853Z",
    fill: "#523280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a751d671f6b4bb7f853d9c82c857a03d.svg";
export { ForwardRef as ReactComponent };